import { ModelBase } from './model';

class CourseSchedule extends ModelBase {
  static namespace = 'course_schedules';
}
export default CourseSchedule.register();
